export default "__VITE_ASSET__oEzq9Ek___"